import axios from "axios";

console.log({env:process.env})

const DOMAIN = process.env.VUE_APP_API_DOMAIN;
const API_BASE_PATH = process.env.VUE_APP_API_BASE_PATH;
const BASE_URI = `${DOMAIN}${API_BASE_PATH}`


const APPLY_FORM_CONFIG_PATH = "apply-form/config";
const ATTENDEE_SUBMIT = "attendees/submit";
const EVENT_DETAIL = "event/detail";

const MOBILE_SEND_VALIDATION = "attendees/send_verification_code";
const EMAIL_SEND_VALIDATION = "attendees/email/send_verification_code";
const VERIFY_VALIDATION = "attendees/verify_verification_code";
const FILE_PATH = "file";

const CAPTCHA = "captcha";
const CAPTCHA_VALIDATION = "captcha/verify";

const MESSAGE_TEMPLATE = 'rsvp/message-template/get-by-slug'

const ATTENDEE_INFO = 'attendees/apply-info'



export async function getAttendeeInfo(uuid) {
  try {
    const url =   `${BASE_URI}/${ATTENDEE_INFO}/${uuid}`;

    const response = await axios.get(url);
    console.log("getAttendeeInfo",{url,response});
    handleErrorInfo(response);
    return response.data.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}



export function getBannerUrl(banner){
  return  `${BASE_URI}/${FILE_PATH}/${banner}`;

}

export function getFormPublicUrl(formKey,formLang){
  return `${window.location.origin}${process.env.VUE_APP_PUBLIC_PATH}?formKey=${formKey}&lang=${formLang}`;
}

export async function getMessageTemplate(slug) {
  try {
    const url = `${BASE_URI}/${MESSAGE_TEMPLATE}`;
    
    const response = await axios.get(url,{params:{slug}});
    console.log("getMessageTemplate");
    handleErrorInfo(response);
    return response.data.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}


function handleError(response) {
  if (response.data && response.data.code == -1) {
    throw new Error(response.data.message);
  }
}

function handleErrorInfo(response) {
  if (response.data && response.data.code == -1) {
    let e = new Error(
      response.data.message ? response.data.message : "error code -1"
    );
    e.source = response;
    throw e;
  }
  if (!response.data.isSuccess) {
    const errorPrefix = "apply form api error";
    let msg = response.data.message
      ? `${errorPrefix}: ${response.data.message}`
      : errorPrefix;
    let code = response.data.code ? response.data.code : "";
    if (code && !response.data.message) {
      msg = `${msg}: ${code}`;
    }
    let err = new Error(msg);
    err.name = "ApplyForm Error";
    if (code) {
      err.code = response.data.code * 1;
    }
    err.source = response.data;
    if (Error && Error.captureStackTrace) Error.captureStackTrace(err);
    throw err;
  }
}
/* publish */

export async function sendMobileVerification(mobile,locale) {
  try {
    const url = `${BASE_URI}/${MOBILE_SEND_VALIDATION}`;
    const response = await axios.post(url, { mobile,locale });
    handleError(response);
    console.log("sendMobileVerification", { mobile,locale });
    return response.data.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function sendEmailVerification(Title, Email,locale) {
  try {
    const url = `${BASE_URI}/${EMAIL_SEND_VALIDATION}`;

    const response = await axios.post(url, { Title, Email,locale });
    console.log("sendEmailVerification", { Title, Email,locale });

    handleErrorInfo(response);
    return response.data.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function getCaptcha() {
  try {
    const url = `${BASE_URI}/${CAPTCHA}`;

    const response = await axios.get(url);
    console.log("getCaptcha");

    handleErrorInfo(response);
    return response.data.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
// {
//   "isSuccess": true,
//   "code": 0,
//   "data": {
//     "id": "92425afeb8f4409facb1cb66d98fae1d"
//   },
//   "message": "OK",
//   "type": 200,
//   "errorInfo": null
// }

export async function verifyCode(Id, VerifyCode) {
  try {
    const url = `${BASE_URI}/${VERIFY_VALIDATION}`;

    const response = await axios.post(url, { Id, VerifyCode });
    if (response.data.code == 302005) {
      response.data.data = false;
    } else if (response.data.code == 302004) {
      response.data.data = false;
      response.data.expired = true;
    } else {
      handleErrorInfo(response);
    }
    console.log("verifyCode", { Id, VerifyCode, response });
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function verifyCaptchaCode(CaptchaKey, CaptchaCode) {
  try {
    const url = `${BASE_URI}/${CAPTCHA_VALIDATION}`;

    let response = await axios.post(url, null, {
      params: { CaptchaKey, CaptchaCode },
    });
    if (response.data.code == 302005) {
      response.data.data = false;
    } else if (response.data.code == 302004) {
      response.data.data = false;
      response.data.expired = true;
    } else {
      handleErrorInfo(response);
    }
    console.log("verifyCaptchaCode", { CaptchaKey, CaptchaCode });
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

// {
//   "isSuccess": true,
//   "code": 0,
//   "message": "string",
//   "type": 200,
//   "errorInfo": {
//     "code": "string",
//     "message": "string",
//     "details": "string",
//     "data": {},
//     "validationErrors": [
//       {
//         "message": "string",
//         "members": [
//           "string"
//         ]
//       }
//     ]
//   }
// }

export async function getEventBanner(eventId) {
  try {
    const url = `http://gep.tiger.wizmacau.com/api/event/detail`;

    const response = await axios.get(url, { params: { eventId } });
    handleError(response);
    console.log("getEventBanner", { eventId });
    return response.data.data.banner;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
export async function getApplyForm(formKey, previewKey, inviteCode) {
  try {
    const url = `${BASE_URI}/${APPLY_FORM_CONFIG_PATH}`;
    const response = await axios.get(url, {
      params: { formKey, previewKey, inviteCode },
    });
    handleErrorInfo(response);
    console.log("getApplyForm", { formKey, previewKey, inviteCode, response });
    return response.data.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function getEventDetail(id) {
  try {
    const url = `${BASE_URI}/${EVENT_DETAIL}`;
    const response = await axios.get(url, { params: { id } });
    handleErrorInfo(response);
    console.log("getEventDetail", { id, response });
    return response.data.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function submitForm(params) {
  try {
    const url = `${BASE_URI}/${ATTENDEE_SUBMIT}`;
    const response = await axios.post(url, params);
    handleErrorInfo(response);
    console.log("submitForm", { params, response });

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
